"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIcon = exports.USER_ICON_SIZE = exports.Root = exports.NoUserImageWrapper = exports.Label = exports.ContactsWrapper = exports.ContactsRow = exports.AddressWrapper = exports.AddressRow = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const USER_ICON_SIZE = exports.USER_ICON_SIZE = 45;
const Root = exports.Root = (0, _mui.styled)('section')(({
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  display: 'inline-block',
  minWidth: 360,
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4, 6)
  }
}));
const Label = exports.Label = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  paddingBottom: theme.spacing(4)
}));
const userIconStyles = {
  borderRadius: '50%',
  height: USER_ICON_SIZE,
  width: USER_ICON_SIZE
};
const UserIcon = exports.UserIcon = (0, _mui.styled)(_components.LazyImage)(({
  ownerState: {
    isOnlyFirstRow
  }
}) => ({
  ...userIconStyles,
  ...(!isOnlyFirstRow && {
    gridRow: '1/4'
  }),
  [`& img`]: {
    objectFit: 'cover',
    ...userIconStyles
  }
}));
const NoUserImageWrapper = exports.NoUserImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.grey[100],
  color: theme.palette.grey[900],
  display: 'flex',
  fontSize: '2.4rem',
  justifyContent: 'center',
  ...userIconStyles
}));
const AddressWrapper = exports.AddressWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isOnlyFirstRow
  },
  theme
}) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: 'grid',
  columnGap: theme.spacing(2),
  gridTemplateColumns: `${USER_ICON_SIZE}px 1fr`,
  paddingBottom: theme.spacing(3),
  ...(isOnlyFirstRow && {
    alignItems: 'center'
  })
}));
const AddressRow = exports.AddressRow = (0, _mui.styled)(_mui.Typography)({
  gridColumn: 2
});
const ContactsWrapper = exports.ContactsWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingTop: theme.spacing(3)
}));
const ContactsRow = exports.ContactsRow = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2)
}));
//# sourceMappingURL=styles.js.map